const { serialize } = require("../../../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/legal/contracts",
  },
  actions: {
    getRequestedCancels({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/requested-cancels?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    confirmRequest({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/confirm-request`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    rejectRequest({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/reject-request`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
